export function getBaseUrl() {
  let baseUrl
  try {
    baseUrl = window.location.origin
  } catch (e) {
    baseUrl = process.env.BASE_URL
  }
  if (!baseUrl) {
    throw new Error('No base URL found')
  }
  return baseUrl
}
